import script from "./ChecklistModeloEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChecklistModeloEditPage.vue?vue&type=script&setup=true&lang=js"

import "./ChecklistModeloEditPage.vue?vue&type=style&index=0&id=db8e008e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db8e008e"]])

export default __exports__